import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { assignRef } from "../../common-data/Commons";
import SelectDropdown from "../../components-react/SelectDropdown";
import { validateWalkinsForm } from "./Validations";
import { fetchGymData } from "../../../data/APIs";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { fetchReceptionistBySlotData } from "../../../redux/reducers/dropdownApiSlice";
import Modal from "react-modal";
import VerifyOTPMobile from "../../../components/staff-onboarding/on-boarding-form/VerifyOTPMobile";
import {
  otpRequestMobile,
  otpVerifyMobile,
  otpRequestEmail,
  otpVerifyEmail,
} from "../../../data/ApiEndpoints";
import { gender } from "../../common-data/DropdowData";
import { currentMonthCurrentDate } from "../../common-data/Converts";

const WalkinsForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const formRef = useRef({});
  const timerIdRef = useRef(null);

  const gymData = useSelector(selectGymData);
  const { receptionistBySlot } = useSelector((state) => state.dropdown);
  const { postPutLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";

  const iniFormValues = {
    custName: rowData.user_name || "",
    custMobile: rowData.user_mobile || "",
    custEmail: rowData.user_email || "",
    selectedGym:
      rowData?.gym_id && rowData?.gym_name
        ? { label: rowData.gym_name, value: rowData.gym_id }
        : !isAdmin
        ? {
            label: userInfoData?.gym_name,
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    isAssignDifferentReceptionist: isAdmin ? true : false,
    selectedReceptionist: "",
    selectedGender: "",
    memberDOB: "",
    remarks: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    otp: "",
    timerCount: "",
    requestNumber: "",
    requestEmail: "",
    isMobileVerified: false,
    isEmailVerified: false,
  };
  const [modValues, setModValues] = useState(iniModValues);

  function getReceptionistBySlot(filter) {
    dispatch(
      fetchReceptionistBySlotData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "custMobile" && value.length > 10) {
      return;
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedReceptionist: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const closeModValues = () => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: false,
      modName: "",
      otp: "",
      timerCount: "",
    }));
  };

  const startTimer = () => {
    setModValues((prevs) => ({ ...prevs, timerCount: 60 }));

    if (timerIdRef.current) {
      clearInterval(timerIdRef.current);
    }

    timerIdRef.current = setInterval(() => {
      setModValues((prevs) => {
        if (prevs.timerCount > 0) {
          return { ...prevs, timerCount: prevs.timerCount - 1 };
        } else {
          clearInterval(timerIdRef.current);
          return prevs;
        }
      });
    }, 1000);
  };

  const handleRequestOTP = async (payload, apiEndoint, callFor) => {
    const method = "POST";
    const endpoint = apiEndoint;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        if (callFor === "request-otp") {
          startTimer();
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: payload.email ? "request-email-otp" : "request-mobile-otp",
            requestNumber: formValues.custMobile,
            requestEmail: formValues.custEmail,
            otp: "",
          }));
        } else if (callFor === "verify-otp") {
          const isMobileOTP = modValues.modName === "request-mobile-otp";
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: false,
            modName: "",
            otp: "",
            isMobileVerified: isMobileOTP ? true : prevs.isMobileVerified,
            isEmailVerified: !isMobileOTP ? true : prevs.isEmailVerified,
          }));
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        setModValues((prevs) => ({
          ...prevs,
          otp: "",
        }));
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onClickFetchDetails = (request) => {
    if (request === "request-mobile-otp") {
      if (!formValues.custMobile) {
        setFormErrors((prevs) => ({
          ...prevs,
          custMobile: "Required!",
        }));
        return;
      }

      if (formValues.custMobile.length !== 10) {
        setFormErrors((prevs) => ({
          ...prevs,
          custMobile: "Must be exactly 10 digits!",
        }));
        return;
      }

      const payload = {
        mobile: formValues.custMobile,
        otp_type: "sms",
        sms: 1,
      };

      handleRequestOTP(payload, otpRequestMobile, "request-otp");
    } else if (request === "request-email-otp") {
      if (!formValues.custEmail) {
        setFormErrors((prevs) => ({
          ...prevs,
          custEmail: "Required!",
        }));
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.custEmail)) {
        setFormErrors((prevs) => ({
          ...prevs,
          custEmail: "Invalid email format!",
        }));
        return;
      }

      const payload = {
        email: formValues.custEmail,
        otp_type: "email",
      };

      handleRequestOTP(payload, otpRequestEmail, "request-otp");
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? "/" : "/leads/walkin";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(iniFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    const errors = validateWalkinsForm(formValues, modValues);
    setFormErrors(errors);
    setIsSubmit(true);

    // if (Object.keys(errors).length === 0 && isSubmitDisabled()) {
    //   toast.error(
    //     "Mobile number and email (if applicable) must be verified before submitting"
    //   );
    //   return;
    // }

    if (formRef.current && Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );

      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      selectedGym:
        rowData?.gym_id && rowData?.gym_name
          ? { label: rowData.gym_name, value: rowData.gym_id }
          : !isAdmin
          ? {
              label: userInfoData?.gym_name,
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
    }));
  }, []);

  console.log(rowData, " <=userInfoData=> ", userInfoData?.gym_name);

  useEffect(() => {
    if (formValues.isAssignDifferentReceptionist || isAdmin) {
      dispatch(fetchGymData(userInfoData?.token));
    }
  }, [formValues.isAssignDifferentReceptionist]);

  useEffect(() => {
    const filters = {
      gym_id: formValues.selectedGym?.value || "",
      status: "active",
    };

    getReceptionistBySlot(filters);
  }, [formValues.isAssignDifferentReceptionist, formValues.selectedGym]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.custName,
        mobile: formValues.custMobile,
        email: formValues.custEmail || "",
        gym_id: formValues.selectedGym?.value || "",
        assisted_by:
          isAdmin || formValues.selectedReceptionist?.value
            ? formValues.selectedReceptionist?.value
            : userInfoData?.user_id || userInfoData?.uid || "",
        submission_type: "staff",
        remarks: formValues.remarks || "",
        ratings: {},
        dob: formValues.memberDOB || "",
        gender: formValues.selectedGender?.value || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`, "Add Form", "Add Lead");
    }
  }, [isSubmit, formErrors]);

  console.log(userInfoData, " <=formValues=> ", formValues);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox">
            <label htmlFor="custName" className={`formInputLabel`}>
              Customer Name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Full Name"
              className={`formInput ${formErrors?.custName ? "formError" : ""}`}
              name="custName"
              value={formValues.custName}
              onChange={onChangeInput}
              ref={assignRef("custName", formRef)}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="custMobile" className={`formInputLabel`}>
              Customer Mobile <span className="required">*</span>
            </label>

            <div className="input-add-btn flexBetween">
              <input
                type="number"
                placeholder="Enter Mobile Number"
                className={`formInput ${
                  formErrors?.custMobile ? "formError" : ""
                }`}
                name="custMobile"
                value={formValues.custMobile}
                onChange={onChangeInput}
                min={0}
                ref={assignRef("custMobile", formRef)}
                disabled={modValues?.isMobileVerified}
              />

              <button
                type="button"
                className="btn btn-dark black-btn"
                onClick={() => {
                  if (modValues?.isMobileVerified) {
                    setFormValues((prevs) => ({
                      ...prevs,
                      custMobile: "",
                    }));
                    setModValues((prevs) => ({
                      ...prevs,
                      isMobileVerified: false,
                    }));
                  } else {
                    onClickFetchDetails("request-mobile-otp");
                  }
                }}>
                {modValues?.isMobileVerified ? "clear" : "verify"}
              </button>
            </div>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="custEmail" className={`formInputLabel`}>
              Customer Email <span className="not required">(Optional)</span>
            </label>

            <div className="input-add-btn flexBetween">
              <input
                type="email"
                placeholder="Enter Email Address"
                className={`formInput ${
                  formErrors?.custEmail ? "formError" : ""
                }`}
                name="custEmail"
                value={formValues.custEmail}
                onChange={onChangeInput}
                disabled={modValues?.isEmailVerified}
              />

              {formValues.custEmail && (
                <button
                  type="button"
                  className="btn btn-dark black-btn"
                  onClick={() => {
                    if (modValues?.isEmailVerified) {
                      setFormValues((prevs) => ({
                        ...prevs,
                        custEmail: "",
                      }));
                      setModValues((prevs) => ({
                        ...prevs,
                        isEmailVerified: false,
                      }));
                    } else {
                      onClickFetchDetails("request-email-otp");
                    }
                  }}>
                  {modValues?.isEmailVerified ? "clear" : "verify"}
                </button>
              )}
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedGender" className={`formInputLabel`}>
              member gender <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGender ? "formError" : ""
              }`}>
              <SelectDropdown
                options={gender.slice(0, -1)}
                selectedOption={formValues.selectedGender}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedGender", selectedValue)
                }
                name="Gender"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberDOB" className="formInputLabel">
              member DOB <span className="required">*</span>
            </label>

            <input
              type="date"
              className={`formInput ${
                formValues.memberDOB ? "date-has-value" : ""
              } ${formErrors.memberDOB ? "formError" : ""}`}
              name="memberDOB"
              value={formValues.memberDOB}
              onChange={onChangeInput}
              ref={assignRef("memberDOB", formRef)}
              max={currentMonthCurrentDate}
            />
          </div>

          <div className="formInputBox span2">
            <label
              htmlFor="selectedGym"
              className={`formInputLabel `}
              ref={assignRef("selectedGym", formRef)}>
              Gym {isAdmin && <span className="required">*</span>}
            </label>

            {!formValues.isAssignDifferentReceptionist ? (
              <input
                type="text"
                className="formInput"
                name="selectedGym"
                placeholder={`🚫 ${formValues.selectedGym?.label || "NA"}`}
                disabled
              />
            ) : (
              <div
                className={`commonWrapper ${
                  formErrors.selectedGym ? "formError" : ""
                }`}>
                <SelectDropdown
                  options={gymData?.length > 0 ? gymData : []}
                  selectedOption={formValues.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedGym", selectedValue)
                  }
                  name="Gym"
                />
              </div>
            )}

            <Form.Check
              type="checkbox"
              name="isAssignDifferentReceptionist"
              className={`${
                formErrors?.isAssignDifferentReceptionist ? "formError" : ""
              }`}
              style={{
                cursor: isAdmin ? "not-allowed" : "pointer",
              }}
              label={`${"Assign To Sales Executive"}`}
              checked={formValues.isAssignDifferentReceptionist}
              onChange={onChangeInput}
              disabled={isAdmin}
            />
          </div>

          {formValues.isAssignDifferentReceptionist &&
          formValues.selectedGym ? (
            <>
              <div className="formInputBox">
                <label
                  htmlFor="selectedReceptionist"
                  className={`formInputLabel`}>
                  Sales Executive <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedReceptionist ? "formError" : ""
                  }`}
                  ref={assignRef("selectedReceptionist", formRef)}>
                  <SelectDropdown
                    options={
                      receptionistBySlot?.length > 0 ? receptionistBySlot : []
                    }
                    selectedOption={formValues.selectedReceptionist}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedReceptionist", selectedValue)
                    }
                    name="Sales Executive"
                  />
                </div>

                {formValues.isAssignDifferentReceptionist &&
                receptionistBySlot?.length === 0 ? (
                  <span className="info">{`No Sales Executive Is Availble`}</span>
                ) : null}
              </div>
            </>
          ) : null}

          <div className="formInputBox span3">
            <label htmlFor="remarks" className="formInputLabel">
              Remarks
            </label>

            <textarea
              name="remarks"
              className={`formInput ${formErrors.remarks ? "formError" : ""}`}
              placeholder="Enter Remarks"
              value={formValues.remarks}
              onChange={onChangeInput}
              ref={assignRef("remarks", formRef)}></textarea>

            {formErrors?.custEmail && (
              <span className="error-label">{formErrors.custEmail}</span>
            )}

            {formErrors?.custMobile && (
              <span className="error-label">{formErrors.custMobile}</span>
            )}
          </div>
        </div>

        <CloseSubmitBtn
          closeLabel="Cancel"
          submitLabel={"Submit"}
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={postPutLoading}
          // isSubmitDisabled={isSubmitDisabled()}
        />
      </form>

      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModValues}
        contentLabel="OTP Verification Modal"
        ariaHideApp={false}>
        <VerifyOTPMobile
          modValues={modValues}
          setModValues={setModValues}
          onClickResend={() =>
            onClickFetchDetails(
              modValues.modName === "request-email-otp"
                ? "request-email-otp"
                : "request-mobile-otp"
            )
          }
          onClickSubmit={() => {
            const payload = {
              mobile: modValues.requestNumber,
              email: modValues.requestEmail,
              otp: modValues.otp,
            };
            handleRequestOTP(
              payload,
              modValues.modName === "request-email-otp"
                ? otpVerifyEmail
                : otpVerifyMobile,
              "verify-otp"
            );
          }}
          closeModValues={closeModValues}
        />
      </Modal>
    </div>
  );
};

export default WalkinsForm;
